import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import OurGalleryOfExcellence from "./sections/OurGalleryOfExcellence";
import TheFinalDetail from "./sections/TheFinalDetail";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <OurGalleryOfExcellence />
      <TheFinalDetail />
      <Footer />
    </div>;
}